import React from 'react';

const NotificationsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Notifications
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Notifications page shows all alerts, updates, and important messages
          for your account. Stay informed about system events, support updates,
          and other relevant activities.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Notification Types
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Different types of notifications you may receive:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Support:</strong> Updates on support tickets</li>
          <li><strong>System:</strong> Platform updates and maintenance</li>
          <li><strong>Alerts:</strong> Cost anomalies, compliance issues</li>
          <li><strong>Project:</strong> Project milestones and updates</li>
          <li><strong>Security:</strong> Security-related notifications</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Managing Notifications
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Control your notification experience:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Mark as Read:</strong> Clear unread status</li>
          <li><strong>Mark All Read:</strong> Clear all unread notifications</li>
          <li><strong>Delete:</strong> Remove individual notifications</li>
          <li><strong>Filter:</strong> View by type or status</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Notification Preferences
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Customize how you receive notifications in Settings:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>In-App:</strong> Notifications within the platform</li>
          <li><strong>Email:</strong> Email notifications for important events</li>
          <li><strong>Digest:</strong> Daily or weekly summary emails</li>
          <li><strong>Per Category:</strong> Configure each notification type</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Real-Time Updates
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Notifications appear in real-time across the platform. The bell icon
          in the navigation shows your unread count. Click any notification
          to navigate directly to the related item.
        </p>
      </div>

    </>
  );
};

export default NotificationsHelp;
